<main id="main-content" class="main-content">
  @if (errorList.length > 0) {
    <div class="red-warning">
      <mat-icon class="red-warn-icon">warning</mat-icon>
      <div class="red-warn-text">
        <span class="red-title">Incomplete section</span>
        <span class="red-text">
          The following fields are missing details. Please complete them before proceeding to the next section:
          <ul>
            @for (error of errorList; track error) {
              <li>{{error | titlecase}}</li>
            }
          </ul>
        </span>
      </div>
    </div>
  }
  @if (report().geo_area_choice == '02') {
    <div class="blue-warning">
      <fa-icon class="fa-sm blue-warn-icon" [icon]="faLock"></fa-icon>
      <div class="support-text">
        <div class="support-title">Section Locked</div>
        The <b>Report type</b> section is locked and cannot be modified. GIS data from the Assessment Boundary, Soil
        Burn Severity, and Treatment Summaries have been copied from the initial report, which prevents modification
        of this section.
      </div>
    </div>
  }
  <div class="subtitle"><span class="red">*</span>Indicates required field</div>
  <h2 class="form-header">1. Report Type</h2>
  @if (!partialSelection) {
    <mat-card [formGroup]="form">
      <div class="title"><span class="red">*</span>Report Type
      <mat-icon [matTooltip]="'Learn more about each report type.'" matTooltipClass="tooltipClass"
        (click)="reportTypeModal($event)" onKeyUp="reportTypeModal($event)"
        (keyup.enter)="reportTypeModal($event)" focusable aria-hidden="false"
      class="info-blue-field fa-regular fa-circle-info">info_outline</mat-icon>
    </div>
    <mat-radio-group required class="radio-buttons" formControlName="report_type">
      <mat-radio-button [value]="'Emergency Stabilization'" color="primary">Funding Request for Estimated
      Emergency Stabilization Funds</mat-radio-button>
      <br>
        <mat-radio-button [value]="'No Treatment'" color="primary">No Treatment
        Recommendation</mat-radio-button>
        <br>
          <mat-radio-button [value]="'Pre-assessment Request'" color="primary">Pre-assessment Funding
          Request</mat-radio-button>
        </mat-radio-group>
        <div class="title"><span class="red">*</span>Does this assessment cover the full fire area or a phased area?
        <mat-icon
          [matTooltip]="'Learn more about the difference between a full fire assessment and a phased assessment'"
          matTooltipClass="tooltipClass" (click)="fullVsPhasedModal($event)" onKeyUp="fullVsPhasedModal($event)"
          (keyup.enter)="fullVsPhasedModal($event)" focusable aria-hidden="false"
        class="info-blue-field fa-regular fa-circle-info">info_outline</mat-icon>
      </div>
      <mat-radio-group required class="radio-buttons" formControlName="initial_report_type">
        <mat-radio-button [value]="'Full Fire Assessment'" color="primary">Full Fire Assessment</mat-radio-button>
        <br>
          <mat-radio-button [value]="'Phased Assessment'" color="primary">Phased Assessment</mat-radio-button>
        </mat-radio-group>
      </mat-card>
    }
    @if (partialSelection) {
      <mat-card [formGroup]="form">
        <div class="title"><span class="red">*</span>Are you continuing with a phased assessment or combining all phased
        into a full fire assessment?
        <mat-icon
          [matTooltip]="'Learn more about the difference between a full fire assessment and a phased assessment'"
          matTooltipClass="tooltipClass" (click)="fullVsPhasedModal($event)" onKeyUp="fullVsPhasedModal($event)"
          (keyup.enter)="fullVsPhasedModal($event)" focusable aria-hidden="false"
        class="info-blue-field fa-regular fa-circle-info">info_outline</mat-icon>
      </div>
      <mat-radio-group required class="radio-buttons" formControlName="initial_report_type">
        <mat-radio-button [value]="'Phased Assessment'" color="primary">Continue with a Phased
        Assessment</mat-radio-button>
        <br>
          <mat-radio-button [value]="'Full Fire Assessment'" color="primary">Combine all Phased into Full Fire
          Assessment</mat-radio-button>
        </mat-radio-group>
      </mat-card>
    }
  </main>